
import { useState } from "react";
import AppLayout from "@/components/layout/AppLayout";
import { useUserRoles } from "@/hooks/useUserRoles";
import { AddTeamForm } from "./components/AddTeamForm";
import { TeamHeader } from "./components/TeamHeader";
import { TeamList } from "./components/TeamList";
import { ErrorDisplay } from "./components/ErrorDisplay";
import { useTeamsData } from "./hooks/useTeamsData";
import { useTeamActions } from "./hooks/useTeamActions";

const Teams = () => {
  const [isAddTeamOpen, setIsAddTeamOpen] = useState(false);
  const { isAdmin, isLoading: rolesLoading, error: rolesError } = useUserRoles();
  
  // Use our custom hooks - fix destructuring
  const { data: teams, isLoading, error, refetch } = useTeamsData();
  const { deleteTeam } = useTeamActions();

  // If roles fail to load, default to non-admin but still show the page
  const adminStatus = rolesError ? false : !!isAdmin;

  const handleDeleteTeam = async (team: any) => {
    await deleteTeam(team);
    await refetch();
  };

  const handleSuccess = async () => {
    console.log('Team added successfully, refetching teams');
    await refetch();
  };

  if (error) {
    return (
      <AppLayout>
        <ErrorDisplay message={error.message} />
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted/30 relative overflow-hidden">
        {/* Enhanced background patterns */}
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-blue-500/5 pointer-events-none"></div>
        <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-radial from-blue-500/10 to-transparent rounded-full blur-3xl pointer-events-none animate-pulse"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-radial from-primary/10 to-transparent rounded-full blur-3xl pointer-events-none animate-pulse" style={{ animationDelay: '2s' }}></div>
        
        <div className="relative z-10 space-y-8 animate-fadeIn px-4 sm:px-6 lg:px-8 pt-6 pb-12">
          <TeamHeader 
            isAdmin={adminStatus} 
            onAddTeam={() => setIsAddTeamOpen(true)} 
          />
          
          <TeamList
            teams={teams || []}
            isLoading={isLoading && !rolesError}
            isAdmin={adminStatus}
            onDeleteTeam={handleDeleteTeam}
          />
        </div>

        <AddTeamForm 
          isOpen={isAddTeamOpen}
          onClose={() => setIsAddTeamOpen(false)}
          onSuccess={handleSuccess}
        />
      </div>
    </AppLayout>
  );
};

export default Teams;
